export const sandoItems = [
  {
    id: "sando-queso-nori",
    name: "SANDO QUESO CON ALGA NORI",
    price: "$32.000",
    description:
      "Ajonjolí, miel, tocino, pan de leche, cebolla de Granja La Arandela y mayonesa.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photograph%20of%20a%20japanese%20style%20milk%20bread%20sando%20with%20cheese%20and%20nori%20seaweed%2C%20sesame%20seeds%2C%20honey%2C%20bacon%20and%20mayonnaise%2C%20cut%20in%20half%20showing%20the%20layers%2C%20dark%20wooden%20board%2C%20warm%20amber%20lighting%2C%20moody%20editorial%20food%20photography&width=800&height=500&seq=clem-sando-queso-nori&orientation=landscape",
  },
  {
    id: "sando-pollo",
    name: "SANDO DE POLLO 150 gr",
    price: "$30.000",
    description:
      "Trozo de pechuga apanada, con lechuga de Granja La Arandela, tocino, queso, miel, mayonesa y BBQ.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photograph%20of%20a%20crispy%20breaded%20chicken%20sando%20with%20lettuce%2C%20bacon%2C%20cheese%2C%20honey%2C%20mayonnaise%20and%20barbecue%20sauce%20in%20milk%20bread%2C%20cut%20in%20half%20showing%20the%20layers%2C%20dark%20wooden%20board%2C%20warm%20amber%20lighting%2C%20moody%20editorial%20food%20photography&width=800&height=500&seq=clem-sando-pollo&orientation=landscape",
  },
];